const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`66cc9447202470ff55881f9b8faf5ee06d4096c548b2666c98f9034d7feb6701`, `66cc9447202470ff55881f9b8faf5ee06d4096c548b2666c98f9034d7feb6701`, 1, 87), new Map([[`label`, `Email`]]), false, false, 1));
            }

            getTemplateName() {
                return `66cc9447202470ff55881f9b8faf5ee06d4096c548b2666c98f9034d7feb6701`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `66cc9447202470ff55881f9b8faf5ee06d4096c548b2666c98f9034d7feb6701`, ``);
            }
        }],
        [87, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/form-group/form-group.twig`, `66cc9447202470ff55881f9b8faf5ee06d4096c548b2666c98f9034d7feb6701`, 1);

                this.blocks = new Map([
                    ['control', [this, 'block_control']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/form-group/form-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_control(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, new Map([[`type`, `email`]]), false, false, 3));
                this.echo(`  `);
            }

            getTemplateName() {
                return `66cc9447202470ff55881f9b8faf5ee06d4096c548b2666c98f9034d7feb6701`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `66cc9447202470ff55881f9b8faf5ee06d4096c548b2666c98f9034d7feb6701`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '66cc9447202470ff55881f9b8faf5ee06d4096c548b2666c98f9034d7feb6701');

let template = env.loadTemplate('66cc9447202470ff55881f9b8faf5ee06d4096c548b2666c98f9034d7feb6701');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/form-group/demo/input.twig", args: context }
     );
     return rendered;;
};